<div class="modal">
  <div class="container model-container {{data.customClass}}">
    <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon" width="32" height="32"
      alt="Close Icon">
    <div class="modal-header">
      <h4 class="modal-heading">Change Password</h4>
    </div>
    <div class="modal-body">
      <div class="modal-content" *ngIf="step === 1">
        <p class="smaller text-content">Enter your current password to verify and proceed:</p>

        <form [formGroup]="currentPasswordForm">
          <label class="outlined-input" [class.input-error]="showCurrentError">
            <input [type]="showCurrentPassword ? 'text' : 'password'" formControlName="password"
              (input)="preventInputFocus($event);showCurrentError = false" (mousedown)="preventInputFocus($event)"
              placeholder=" ">
            <span>Current Password <span class="star hide">*</span></span>

            <img class="eye" [src]="showCurrentPassword ? 'assets/icon/eye-slash.svg' :'assets/icon/grey-eye-icon.svg'"
              (click)="showCurrentPassword = !showCurrentPassword" *ngIf="currentPasswordForm.controls.password.value"
              alt="eye icon" height="16" width="16">
          </label>

          <p *ngIf="currentPasswordForm.controls.password.touched && currentPasswordForm.controls.password.hasError('required')"
            class="validation-message">
            Current Password is required
          </p>

          <p *ngIf="showCurrentError" class="validation-message">
            Invalid Password. Try again!
          </p>
        </form>
      </div>

      <div class="modal-content" *ngIf="step === 2">
        <p class="smaller text-content">Enter your new Password:</p>

        <form [formGroup]="newPasswordForm">
          <label class="outlined-input"
            [class.input-error]="newPasswordForm.controls.confirmNewPassword.value && newPasswordForm.hasError('mismatch')">
            <input [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
              (change)="showCurrentError = false" placeholder=" " (focus)="isNewPassFocused = true"
              (blur)="isNewPassFocused = false">

            <span>Enter New Password <span class="star hide">*</span></span>

            <img class="eye" [src]="showNewPassword ? 'assets/icon/eye-slash.svg' :'assets/icon/grey-eye-icon.svg'"
              (click)="preventInputFocus($event);showNewPassword = !showNewPassword;"
              (mousedown)="preventInputFocus($event)" *ngIf="newPasswordForm.controls.newPassword.value" alt="eye icon"
              height="16" width="16">
          </label>

          <p *ngIf="newPasswordForm.controls.newPassword.touched && newPasswordForm.controls.newPassword.hasError('required')"
            class="validation-message">
            New Password is required
          </p>

          <div class="info-banner" *ngIf="isNewPassFocused">
            <div class="banner-box">
              <img alt="info" src="assets/icon/twisted-primary-info.svg" height="16" width="16">
              <div class="banner-note">
                <p class="caption">Passwords must have at least:</p>
                <ul>
                  <li>
                    <img *ngIf="!newPassword.value" src="assets/icon/green-circle.svg" alt="status icon" height="16"
                      width="16">
                    <img *ngIf="newPassword.value"
                      [src]="!newPassword?.hasError('length') ? 'assets/icon/success-check.svg' : 'assets/icon/red-x.svg'"
                      alt="status icon" height="16" width="16">
                    <p class="caption"><b>6-12</b> characters </p>
                  </li>
                  <li>
                    <img *ngIf="!newPassword.value" src="assets/icon/green-circle.svg" alt="status icon" height="16"
                      width="16">
                    <img *ngIf="newPassword.value"
                      [src]="!newPassword?.hasError('lowercase') ? 'assets/icon/success-check.svg' : 'assets/icon/red-x.svg'"
                      alt="status icon" height="16" width="16">
                    <p class="caption">One <b>Small</b> letter</p>
                  </li>
                  <li>
                    <img *ngIf="!newPassword.value" src="assets/icon/green-circle.svg" alt="status icon" height="16"
                      width="16">
                    <img *ngIf="newPassword.value"
                      [src]="!newPassword?.hasError('uppercase') ? 'assets/icon/success-check.svg' : 'assets/icon/red-x.svg'"
                      alt="status icon" height="16" width="16">
                    <p class="caption">One <b>Capital</b> letter</p>
                  </li>
                  <li class="last">
                    <img *ngIf="!newPassword.value" src="assets/icon/green-circle.svg" alt="status icon" height="16"
                      width="16">
                    <img *ngIf="newPassword.value"
                      [src]="!newPassword?.hasError('digit') ? 'assets/icon/success-check.svg' : 'assets/icon/red-x.svg'"
                      alt="status icon" height="16" width="16">
                    <p class="caption">One <b>Digit</b></p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <label class="outlined-input second"
            [class.input-error]="newPasswordForm.controls.confirmNewPassword.value && newPasswordForm.hasError('mismatch')">
            <input [type]="showConfirmPassword ? 'te' : 'password'" formControlName="confirmNewPassword"
              (input)="showCurrentError = false" placeholder=" ">

            <span>Confirm New Password <span class="star hide">*</span></span>

            <img class="eye" [src]="showConfirmPassword ? 'assets/icon/eye-slash.svg' :'assets/icon/grey-eye-icon.svg'"
              (click)="preventInputFocus($event);showConfirmPassword = !showConfirmPassword"
              (mousedown)="preventInputFocus($event)" *ngIf="newPasswordForm.controls.confirmNewPassword.value"
              alt="eye icon" height="16" width="16">
          </label>

          <p *ngIf="newPasswordForm.controls.confirmNewPassword.touched && newPasswordForm.controls.confirmNewPassword.hasError('required')"
            class="validation-message">
            Confirm Password is required
          </p>

          <p *ngIf="newPasswordForm.controls.confirmNewPassword.value && newPasswordForm.hasError('mismatch')"
            class="validation-message">
            Password Codes don't match. Try again
          </p>
        </form>
      </div>

      <div class="modal-actions">
        <button *ngIf="step === 1" class="button primary" (click)="submitCurrentPassword()">Submit</button>
        <button *ngIf="step === 2" class="button primary" (click)="updatePassword()">Save</button>
        <button class="button tertiary" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>
